import React, { useEffect, useRef, useState } from 'react'
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Admin_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { useLocation, useParams } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { ScrollPanel } from 'primereact/scrollpanel';
import './AdminViewCases.css';
var defaultimage = require('../assets/img/userim.png');

export const AdminViewCases = () => {
    const location = useLocation();
    const [globalFilter, setGlobalFilter] = useState('');
    const stepperRef = useRef(null);
    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("CaseID") as any);
    }, [location]);



    const { CaseID } = useParams();
    const [casesdata, setCasesData] = useState<[]>([]);
    const getdata = async () => {
        try {
            const payload = { q: 1, need: CaseID };
            const apiname = Admin_API.viewcases_API;
            const data = await LoginService.getData(apiname, payload);
            setCasesData(data);
        } catch (error) {

        }
    };
    const [chatdata, setChatdata] = useState<[]>([]);

    const getchatdata = async () => {
        try {
            const payload = { q: 3, need: CaseID };
            const apiname = Admin_API.viewcases_API;
            const data1 = await LoginService.getData(apiname, payload);
            setChatdata(data1);
        } catch (error) {

        }
    };
    const [uploaddata, setuploaddata] = useState<[]>([]);

    const getuploaddata = async () => {
        try {
            const payload = { q: 4, need: CaseID };
            const apiname = Admin_API.viewcases_API;
            const data2 = await LoginService.getData(apiname, payload);
            setuploaddata(data2);
        } catch (error) {

        }
    };
    const [ViewDilog, setViewDilog] = useState(false);


    const [Viewdata, setviewdata] = useState({
        DocID: '',
    });
    const viewduring = (rowData: any) => {
        setviewdata({
            DocID: rowData.DocID,
        });
        setViewDilog(true);
        Docview()
    }
    const [viewdata, setViewdata] = useState<[]>([]);

    const Docview = async () => {
        const { DocID } = Viewdata;
        const payload = { q: 7, docid: DocID };
        const apiname = Admin_API.viewcases_API;
        const data2 = await LoginService.getData(apiname, payload);
        setViewdata(data2);
    };
    useEffectOnce(() => {
        getdata()
        getchatdata()
        getuploaddata()

    }, []);
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/viewadmincaseslist.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="main-content">
                <div className="content-wrapper">
                    <div className="grid">
                        <div className="col-9">
                            <h2>Case Details</h2>
                        </div>
                        <div className="col-3">
                            <a
                                title="help"
                                onClick={(e) => openWindow(e, IUrl)}
                                style={{

                                    color: "blue",
                                    fontSize: 15, cursor: "pointer"
                                }}
                            >Help for this Page &nbsp;
                                <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                            </a>
                        </div>
                    </div>
                    <section className="content">
                        <div className="grid">
                            <div className="col-3">
                                {casesdata.map((response: any) => (
                                    <>
                                        <Card>
                                            <div style={{
                                                height: '150px',
                                                backgroundColor: 'rgb(23, 162, 184)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center', // Center horizontally
                                                flexDirection: 'column', // Stack the headings vertically
                                                width: '100%'

                                            }}>
                                                <br></br>

                                                <h2 style={{ margin: '4px', color: 'white' }}>{response.FirstName}</h2>
                                                <h3 style={{ marginBottom: '10px', color: 'white', fontWeight: '100' }}>Doctor</h3>

                                                <img
                                                    src={response.dphoto}
                                                    alt="User Avatar"
                                                    style={{
                                                        width: '100px',
                                                        height: '80px',
                                                        borderRadius: '50%',
                                                        padding: '3px',
                                                        border: '3px solid white',
                                                    }}
                                                />
                                            </div>
                                            <div className="grid">
                                                <div className="col-3">
                                                    <div className="description-block">
                                                        <h5 className="description-header">{response.name}</h5>
                                                        <span className="description-text">Country</span>
                                                    </div>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-3">
                                                    <div className="description-block">
                                                        <h5 className="description-header">{response.SpecilityName}</h5>
                                                        <span className="description-text">Speciality</span>
                                                    </div>
                                                </div>
                                                <div className='col-2'></div>
                                                <div className="col-3">
                                                    <div className="description-block">
                                                        <h5 className="description-header">{response.Phone}</h5>
                                                        <span className="description-text style={{ marginRight: '20px' }} ">Phone</span>
                                                    </div>
                                                </div>
                                            </div>





                                        </Card>
                                        <br></br>
                                        <Card>
                                            <div style={{
                                                height: '150px',
                                                backgroundColor: 'rgb(23, 162, 184)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center', // Center horizontally
                                                flexDirection: 'column', // Stack the headings vertically
                                                width: '100%'
                                            }}>
                                                <br></br>

                                                <h2 style={{ margin: '0', color: 'white', fontWeight: '100' }}>{response.pfname}{response.plname}</h2>
                                                <h3 style={{ margin: '0', color: 'white', fontWeight: '200' }}>Patient</h3>

                                                <img
                                                    src={response.pphoto}
                                                    alt="User Avatar"
                                                    style={{
                                                        width: '100px',
                                                        height: '70px',
                                                        borderRadius: '50%',
                                                        padding: '0px',
                                                        border: '3px solid white',

                                                    }}
                                                />
                                            </div>
                                            <div className="card">
                                                <div className="grid">
                                                    <div className="col-6">
                                                        <div className="description-block">
                                                            <h5 className="description-header">{response.name}</h5>
                                                            <span className="description-text">Country</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="description-block">
                                                            <h5 className="description-header">{response.Phone}</h5>
                                                            <span className="description-text">Phone</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </Card>
                                    </>
                                ))}
                            </div>
                            <div className='col-9'>
                                <Panel header="Case Communication" toggleable>
                                    <ScrollPanel style={{ width: '100%', height: '200px' }} >

                                        <div className="grid">
                                            <div className="col-12">
                                                {chatdata.map((item: any) => (
                                                    <div key={item.id} className="chat-item">
                                                        <img
                                                            className="direct-chat-img"
                                                            src={item.photo === 'https://apps.dinkhoo.com/uploads/content/e_medicall/profile/' ? defaultimage : item.photo}
                                                            alt="User Avatar"
                                                        />
                                                        <div className="chat-content">
                                                            <div className="chat-header">
                                                                <span className="chat-name">{item.name}</span>
                                                                <span className="chat-date">{item.date}</span>
                                                            </div>
                                                            <p className="chat-message">{item.msg}</p>
                                                        </div>
                                                    </div>



                                                ))}
                                            </div>
                                        </div>
                                    </ScrollPanel>


                                </Panel>
                                <Panel header="Document Uploads" toggleable>

                                    <section className="content">
                                        <div className="grid">
                                            <div className="col-12">
                                                <div className="card card-primary">
                                                    {/* <Card title=""> */}
                                                    {/* <Panel header="View Documents"> */}

                                                    <div className="card card-primary">
                                                        <div className="card flex flex-wrap justify-content">
                                                            <span className="p-input-icon-left">
                                                                <i className="pi pi-search" />
                                                                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                            </span>
                                                        </div>
                                                        <DataTable value={uploaddata} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column field="doc_name" sortable header="Document Title"></Column>
                                                            <Column header="Operation" body={(rowData) => (
                                                                <>
                                                                    <Button icon="pi pi-eye" rounded outlined tooltip="View" style={{ backgroundColor: 'white', color: 'blue' }} onClick={() => viewduring(rowData)}></Button>

                                                                </>
                                                            )} />
                                                        </DataTable>
                                                    </div>
                                                    {/* </Panel> */}
                                                    {/* </Card> */}
                                                </div>

                                            </div>
                                            {/* <div className="col-1"></div> */}
                                        </div>
                                    </section>



                                </Panel>





                            </div>
                        </div>

                    </section>

                </div>
            </div>
            <Dialog header="View" style={{ width: '50vw' }} visible={ViewDilog} onHide={() => setViewDilog(false)}>
                <div className="modal-header">
                </div>
                <div className="modal-body">
                    {viewdata.map((response: any, index: number) =>
                        <div key={index}>
                            <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                        </div>
                    )}
                </div>
            </Dialog>

        </div>
    )
}
